const TENOR_API_KEY = 'AIzaSyCFoVvWEqjvUD2zypMpAWy4-2Jcl8hfE00';
const CLIENT_KEY = 'funcommunity_chat';

$(document).ready(function () {
    const $gifBtn = $('.add-gif');
    const $gifInput = $('.gif-search-input');
    const $gifResults = $('.gif-results');
    const $messageInput = $('input[name="message"]');

    let currentQuery = '';
    let nextToken = '';
    let isLoading = false;

    $gifBtn.on('click', function () {
        const isOpen = $gifInput.is(':visible');

        if (isOpen) {
            // Close everything
            $gifInput.hide();
            $gifResults.hide().empty();
        } else {
            // Open and search if input already has a value
            $gifInput.show().focus();

            const query = $gifInput.val();
            currentQuery = query;

            if (query.length >= 2) {
                nextToken = '';
                loadGifs(true);
            }
        }
    });

    $(document).on('click', function (e) {
        const $target = $(e.target);

        const clickedInsideGifUI =
            $target.closest('.gif-search-input').length > 0 ||
            $target.closest('.gif-results').length > 0 ||
            $target.closest('.add-gif').length > 0;

        if (!clickedInsideGifUI) {
            $('.gif-search-input').hide();
            $('.gif-results').hide().empty();
        }
    });

    $gifInput.on('input', function () {
        currentQuery = $(this).val();
        $gifResults.empty().scrollTop(0); // Clear old results

        if (currentQuery.length < 2) {
            $gifResults
                .html('<small>No Results Found</small>')
                .show();
            return;
        }

        nextToken = '';
        loadGifs(true);
    });

    $gifResults.on('scroll', function () {
        const scrollTop = $gifResults.scrollTop();
        const scrollHeight = $gifResults.prop('scrollHeight');
        const offsetHeight = $gifResults.outerHeight();

        if (scrollTop + offsetHeight >= scrollHeight - 100 && !isLoading && nextToken) {
            loadGifs(false);
        }
    });

    function loadGifs(reset = false) {
        if (!currentQuery || isLoading) return;
        isLoading = true;

        const url = new URL('https://tenor.googleapis.com/v2/search');
        url.searchParams.append('q', currentQuery);
        url.searchParams.append('key', TENOR_API_KEY);
        url.searchParams.append('client_key', CLIENT_KEY);
        url.searchParams.append('limit', 12);
        if (nextToken && !reset) {
            url.searchParams.append('pos', nextToken);
        }

        fetch(url)
            .then(res => res.json())
            .then(data => {
                if (reset) {
                    $gifResults.empty().scrollTop(0);
                }

                let hasResults = false;
                nextToken = data.next || '';

                if (data.results && data.results.length > 0) {
                    hasResults = true;
                    data.results.forEach(result => {
                        const gifUrl = result.media_formats?.gif?.url;
                        if (gifUrl) {
                            const img = $('<img>')
                                .attr('src', gifUrl)
                                .on('click', function () {
                                    $messageInput.val(gifUrl);
                                    $gifInput.hide();
                                    $gifResults.hide().empty();
                                });
                            $gifResults.append(img);
                        }
                    });
                }

                if (hasResults) {
                    $gifResults.show();
                } else if (reset) {
                    $gifResults.html('<small>No Results Found</small>').show();
                }
            })
            .finally(() => {
                isLoading = false;
            });
    }
});
